import Chart from './Chart/index';

Chart.install = (Vue) => {
  Vue.component(Chart.name, Chart);
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Chart);
}

export default Chart;



// WEBPACK FOOTER //
// ./src/modules/chart/components/index.js